import type { LucideIcon } from 'lucide-react'
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@teach/ui'

interface Props {
  icon: LucideIcon
  /** Без подсказки — просто кнопка-иконка (например, в углу холста). */
  tooltip?: string
  onClick?: () => void
  ariaLabel: string
  disabled?: boolean
}

/**
 * Shared header icon button: ghost/icon-sm, muted → foreground on hover, with a tooltip.
 * When disabled, the trigger is wrapped in a <span> so the tooltip still fires (a disabled
 * button does not emit pointer events).
 */
export const TooltipIconButton = ({ icon: Icon, tooltip, onClick, ariaLabel, disabled }: Props) => {
  const button = (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={onClick}
      aria-label={ariaLabel}
      disabled={disabled}
      className="text-muted-foreground hover:text-foreground"
    >
      <Icon className="h-4 w-4" />
    </Button>
  )

  if (!tooltip) return button
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {disabled ? <span className="flex">{button}</span> : button}
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  )
}
